import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router'
import { BarLoader } from 'react-spinners'
import { banner_loader } from '../../common/svg_img'
import { refresh } from '../../common/authHelper'
import { TitlePage } from '../../components/TitlePage/TitlePage'


const ServiceAuth = () => {
    const path = useParams()
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(true)
    const [isError, setIsError] = useState(false)

    const checkToken = (refresh_token) => {
        setIsLoading(true)
        refresh({
            token: refresh_token,
            onError: err => {
                console.error(err)
                setIsError(true)
                setTimeout(() => {
                    navigate('../auth')
                }, 3000)
            },
            onCleanup: () => setIsLoading(false)
        })
    }

    useEffect(() => {
        let refresh = path['*']
        checkToken(refresh)
    }, [])

    return (
        <div style={{ width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
            {
                isLoading ?
                    <>
                        <div className="main-loader-box">
                            <embed className='main-loader-box__img' type='image/svg+xml' src={banner_loader} />
                            <h1 className='main-loader-box__title'>Загружаем данные</h1>
                            <BarLoader
                                color="#27BC62"
                                height='18'
                                width='100%'
                                maxWidth='400px'
                                speedMultiplier={1} />
                        </div>
                    </>
                    :
                    <TitlePage
                        title={isError ? 'Что-то пошло не так,' : 'Операция прошла успешно'}
                        style={{
                            textAlign: 'center', color: isError ? 'red' : 'black'
                        }}
                    />
            }
        </div>
    )
}

export { ServiceAuth }